<template>
  <div>
    <LoadingOverlay :isLoading="isLoading" />
    <Notification ref="notification" />
    <ToastContainer />
    <!-- <Header /> -->
    <Header v-if="showAdminHeader" />
    <BlankHeader v-if="showBlankHeader" />
    <CompanyHeader v-else-if="showCompanyHeader" />
    <ContractorHeader v-else-if="showContractorHeader" />
    <DashboardHeader v-else-if="isAdminDashboard" />
    <Breadcrumbs v-if="showBreadcrumbs" :childBreadcrumb="childBreadcrumb"/>

    <div class="min-h-screen bg-gray-50">
        <router-view @setChildBreadcrumb="setChildBreadcrumb" />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Header from '@/components/Header'
import Breadcrumbs from '@/components/Breadcrumbs'
import Notification from '@/components/Notification'
import ToastContainer from '@/components/marketplace/ui/ToastContainer.vue'

// Marketplace - Contractor
import ContractorHeader from '@/components/marketplace/contractor/Header'
// Marketplace - Company
import CompanyHeader from '@/components/marketplace/company/Header'
// Blank header for login pages or places where users shouldn't be logged in
import BlankHeader from '@/components/marketplace/generic/Header'
// DashboardHeader for Marketpalce admin dashboard
import DashboardHeader from '@/components/marketplace/admin/Header'

// Loading overlay
import LoadingOverlay from './components/LoadingOverlay.vue';

export default ({
  // metaInfo: {
  //   // if no subcomponents specify a metaInfo.title, this title will be used
  //   title: 'Default Title',
  //   // all titles will be injected into this template
  //   titleTemplate: '%s | My Awesome Webapp'
  // },
  components: {
    Header,
    ContractorHeader,
    CompanyHeader,
    DashboardHeader,
    BlankHeader,
    Breadcrumbs,
    Notification,
    ToastContainer,
    LoadingOverlay
  },
  data() {
    return {
      childBreadcrumb: '',
      isLoading: false
    }
  },
  provide() {
    return {
      toggleLoading: this.toggleLoading // Make the toggleLoading function available globally
    };
  },
  computed: {
    ...mapState(['isContractorLoggedIn', 'isCompanyLoggedIn']),

    showAdminHeader() {
      return this.$route.meta.adminHeader;
    },
    showContractorHeader() {
      if (this.$route.meta.contractorHeader) {
        return true
      }
    },
    showCompanyHeader() {
      if (this.$route.meta.companyHeader || (this.isCompanyLoggedIn && !this.$route.meta.isAdminDashboard)) {
        return true
      }
    },
    showBlankHeader() {
      return this.$route.meta.blankHeader;
    },
    showBreadcrumbs() {
      return this.$route.meta.breadcrumbs;
    },
    isAdminDashboard() {
      return this.$route.meta.isAdminDashboard;
    }
  },
  methods: {
    setChildBreadcrumb(breadcrumb) {
      this.childBreadcrumb = breadcrumb;
    },
    notify(message, type) {
      this.$refs.notification.showNotification(message, type);
    },
    toggleLoading(status) {
      this.isLoading = status;
    }
  },
  created () {
      document.title = 'Screened Marketplace'

      const isContractorLoggedIn = !!localStorage.getItem('contractorToken');
      const isCompanyLoggedIn = !!localStorage.getItem('companyToken');
      if (isContractorLoggedIn) {
          this.$store.commit('setContractorLoggedIn', true)
          this.$store.commit('setContractorName', localStorage.getItem('contractorName'))
      }
      if (isCompanyLoggedIn) {
          this.$store.commit('setCompanyLoggedIn', true)
      }
  }
})
</script>
<style>
/* .hiddenModal {
    visibility: hidden;
}*/

.disabledSave {
    cursor: not-allowed !important;
    pointer-events: all !important;
    background-color: gray !important;
}

.visibleModal {
    visibility: visible !important;
}
/* HIDE ARROWS FROM NUMBER INPUT */
/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>